<template>
  <div class="groups mt-10">
    <v-container>
      <v-snackbar top v-model="alert" multi-line :color="alert_mode">
        {{ alert_text }}
        <v-btn text @click="alert = false">{{$t('close')}}</v-btn>
      </v-snackbar>
      <v-card class="px-6 pb-0 mb-3">
        <v-row>
          <v-col md="3">
            <h2>{{$t('group_list')}}</h2>
          </v-col>
          <!-- <v-col md="3" class="mt-n4" offset="4">
            
          </v-col>-->
          <!-- <v-col md="3">
            <v-btn block outlined color="primary">
              <v-icon>mdi-download</v-icon>
              <download-excel
                :data="group_report"
                worksheet="Groups"
                name="Groups.xls"
              >Download Report</download-excel>
            </v-btn>
          </v-col>-->
          <v-col md="2" offset="7">
            <v-dialog v-model="addDialog" max-width="1000px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on" block
                  >{{$t('group_add')}}</v-btn
                >
              </template>
              <v-form v-model="valid" ref="addDialog">
                <v-card class="pt-3">
                  <v-card-title>
                    <h3 class="ml-2">{{$t('group_add')}}</h3>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col md="6" sm="6">
                          <v-text-field
                            :label="$t('group_name')"
                            class="mt-2"
                            v-model="addItem.alias"
                            :rules="[rules.required, validator.GroupRequired]"
                          ></v-text-field>
                        </v-col>
                        <v-col md="6" sm="6">
                          <v-row v-for="(item, j) of addItem.zoneMasterId" v-bind:key="j" class="pt-0">
                            <v-col md="8" sm="8" class="pt-4">
                              <v-autocomplete
                                :label="$t('zones')"
                                :items="group_zone"
                                item-text="zonename"
                                v-model="addItem.zoneMasterId[j]"
                                item-value="id"
                                :rules="[rules.required]"
                              ></v-autocomplete>
                            </v-col>
                            <v-col md="4" sm="4" class="pt-1">
                              <div >
                              <v-btn v-if="j !== 0" icon class="mt-4" color="error" @click="removeZoneItem(addItem.zoneMasterId, addItem.zoneMasterId[j])">
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                                <v-btn v-if="j == addItem.zoneMasterId.length-1" icon class="mt-4" color="primary" @click="addZoneItem(addItem.zoneMasterId)">
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="6" sm="6">
                          <v-select
                            :label="$t('level')"
                            :items="level_array"
                            v-model="addItem.level"
                            class="mt-2"
                            @change="getLevel($event, addItem.alias, addItem.id)"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                        <v-col md="6" sm="6">
                          <v-autocomplete
                            v-if="addItem.level != 1"
                             :label="$t('group_parent')"
                            :items="group_list"
                            v-model="addItem.parentSlug"
                            item-text="alias"
                            class="mt-2"
                            item-value="slug"
                            :rules="[rules.required]"
                          ></v-autocomplete>
                        </v-col>
                        <v-col md="6" sm="6">
                          <v-select
                            :items="isShifted"
                            v-model="addItem.isShifted"
                            item-text="name"
                            item-value="id"
                             :label="$t('schedule_type')"
                            class="mt-2"
                            @change="onChangeIsShifted"
                          ></v-select>
                        </v-col>
                        <v-col md="6" sm="6" v-if="excludeShifting()">
                          <v-autocomplete
                            v-if="addItem.isShifted == 1"
                            v-model="addItem.shiftPatternMasterId"
                            :items="listPattern"
                            item-text="schedule_name"
                            item-value="id"
                            :label="$t('list_schedule_pattern')"
                            class="mt-2"
                            @change="onChangePattern"
                            :rules="rules2"
                          ></v-autocomplete>
                        </v-col>
                        <v-col offset="6" md="6" sm="6" v-if="addItem.isShifted == 1 && (excludeShifting())">
                          <v-menu ref="menu" v-model="add_menu_start" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :value="dateFormatted(add_start_date)"
                                 :label="$t('start_date')"
                                readonly
                                v-on="on"
                                color="primary"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="add_start_date"
                              @change="onStartDateChange"
                              no-title
                              scrollable
                              :locale="$t('locale')"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col md="6" sm="6" v-if="gcLiveTrackingEnabled">
                          <p class="subtitle-2 font-weight-bold" style="margin: 1px;">{{$t('group_live_tracking')}}</p>
                          <span>(<i>{{$t('group_desc_tracking')}}</i>)</span>
                        </v-col>
                         <v-col md="6" sm="6" v-if="gcLiveTrackingEnabled">
                          <v-switch
                            v-model="addItem.isTrackLocation "
                            inset
                            color="success"
                            value
                            input-value="true"
                           :label="$t('group_live_tracking')"
                          ></v-switch>
                        </v-col>
                        <v-col md="6" sm="6">
                          <p class="subtitle-2 font-weight-bold" style="margin: 1px;">{{$t('group_lock_time')}}</p>
                          <span>(<i>{{$t('group_desc_time')}}</i>)</span>
                        </v-col>
                        <v-col md="6" sm="6">
                          <p class="subtitle-2 font-weight-bold" style="margin: 1px;">{{$t('group_lock_location')}}</p>
                          <span>(<i>{{$t('group_desc_location')}}</i>)</span>
                        </v-col>
                        <v-col md="6" sm="6">
                          <v-switch
                            v-model="addItem.mandatoryCheckOut"
                            inset
                            color="success"
                            value
                            input-value="true"
                            :label="$t('mandatoryCheckOut')"
                          ></v-switch>
                        </v-col>
                        <v-col md="3" sm="3">
                          <v-switch
                            v-model="addItem.strictAreaIn"
                            inset
                            color="success"
                            value
                            input-value="true"
                            :label="$t('strictAreaIn')"
                          ></v-switch>
                        </v-col>
                        <v-col md="3" sm="3">
                          <v-switch
                            v-model="addItem.strictAreaOut"
                            inset
                            color="success"
                            value
                            input-value="true"
                            :label="$t('strictAreaOut')"
                          ></v-switch>
                        </v-col>
                      </v-row>
                      <div v-if="addItem.isShifted == 0">
                        <span class="title text--primary">Schedule</span>
                        <v-row>
                          <v-col md="4" sm="4">
                            <v-text-field
                              :label="$t('tolerance_in_min')"
                              v-model="addItem.tolerance"
                              :rules="rules4"
                            ></v-text-field>
                          </v-col>
                          <v-col md="4" sm="4">
                            <v-text-field
                              :label="$t('interval_in_min')"
                              v-model="addItem.interval"
                              :rules="rules4"
                            ></v-text-field>
                          </v-col>
                          <v-col md="4" sm="4">
                            <v-select
                             :label="$t('timezone')"
                              v-model="addItem.timezone"
                              :rules="[rules.required]"
                              :items="timezone"
                              item-text="name"
                              item-value="id"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-list-item-content>
                          <span class="subtitle-2 font-weight-bold"
                            >{{$t('schedule_in')}} :</span
                          >
                        </v-list-item-content>
                        <v-row>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('mon')"
                              v-model="addItem.monday_in"
                              type="time"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('tue')"
                              v-model="addItem.tuesday_in"
                              type="time"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                              :label="$t('wed')"
                              v-model="addItem.wednesday_in"
                              type="time"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                              :label="$t('thu')"
                              v-model="addItem.thursday_in"
                              type="time"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('fri')"
                              v-model="addItem.friday_in"
                              type="time"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0"></v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                              :label="$t('sat')"
                              v-model="addItem.saturday_in"
                              type="time"
                              :rules="[rules.weekend]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('sun')"
                              v-model="addItem.sunday_in"
                              type="time"
                              :rules="[rules.weekend]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-list-item-content>
                          <span class="subtitle-2 font-weight-bold"
                            >{{$t('schedule_out')}} :</span
                          >
                        </v-list-item-content>
                        <v-row>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('mon')"
                              v-model="addItem.monday_out"
                              type="time"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('tue')"
                              v-model="addItem.tuesday_out"
                              type="time"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                              :label="$t('wed')"
                              v-model="addItem.wednesday_out"
                              type="time"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                              :label="$t('thu')"
                              v-model="addItem.thursday_out"
                              type="time"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                              :label="$t('fri')"
                              v-model="addItem.friday_out"
                              type="time"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0"></v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                              :label="$t('sat')"
                              v-model="addItem.saturday_out"
                              type="time"
                              :rules="[rules.weekend]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                              :label="$t('sun')"
                              v-model="addItem.sunday_out"
                              type="time"
                              :rules="[rules.weekend]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </div>
                      <div v-else-if="addItem.isShifted == 1 && excludeShifting()">
                        <div v-if="selectedPattern">
                          <span class="title text--primary">{{$t('shift_details')}}</span>
                          <v-row>
                            <v-col md="3">
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title
                                    class="subtitle-2 font-weight-bold"
                                    >{{$t('total_days')}}</v-list-item-title
                                  >
                                  <v-list-item-title class="subtitle-1">{{
                                    selectedPattern.shift_days.length
                                  }}</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-col>
                            <v-col md="3">
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title
                                    class="subtitle-2 font-weight-bold"
                                    >{{$t('tolerance')}}</v-list-item-title
                                  >
                                  <v-list-item-title class="subtitle-1">{{
                                    selectedPattern.tolerance
                                  }}</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-col>
                            <v-col md="3">
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title
                                    class="subtitle-2 font-weight-bold"
                                    >{{$t('timezone')}}</v-list-item-title
                                  >
                                  <v-list-item-title
                                    v-if="selectedPattern.timezone == 7"
                                    class="subtitle-1"
                                    >WIB</v-list-item-title
                                  >
                                  <v-list-item-title
                                    v-else-if="selectedPattern.timezone == 8"
                                    class="subtitle-1"
                                    >WITA</v-list-item-title
                                  >
                                  <v-list-item-title
                                    v-else-if="selectedPattern.timezone == 9"
                                    class="subtitle-1"
                                    >WIT</v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-card>
                                <v-simple-table noboder>
                                  <thead>
                                    <tr class="w-100">
                                      <th class="text-center">{{$t('days')}}</th>
                                      <th class="text-center">{{$t('initial_shift')}}</th>
                                      <th class="text-center">{{$t('default')}}</th>
                                      <th class="text-center">
                                        {{$t('shift_description')}}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody
                                    v-for="(item,
                                    j) of selectedPattern.shift_days"
                                    v-bind:key="j"
                                    fluid
                                  >
                                    <tr
                                      v-for="(pattern,
                                      k) of item.shift_patterns"
                                      v-bind:key="k"
                                    >
                                      <td class="text-center">
                                        {{ k == 0 ? item.day : "" }}
                                      </td>
                                      <td class="text-center" v-if="pattern.shift_master">
                                        {{ pattern.shift_master.schedule_code }}
                                      </td>
                                      <td class="text-center">
                                        <span v-if="pattern.default == true">
                                          (Default)
                                        </span>
                                        <span v-else></span>
                                      </td>
                                      <td class="pt-2 text-center" v-if="pattern.shift_master">
                                        <span class="pb-2">
                                          {{$t('start')}} - {{$t('end')}} :
                                          {{
                                            pattern.shift_master.work_in | hour
                                          }}
                                          -
                                          {{
                                            pattern.shift_master.work_out | hour
                                          }}
                                        </span>
                                        <br />
                                        <span>
                                          {{$t('break_time')}}:
                                          {{
                                            pattern.shift_master.break_in | hour
                                          }}
                                          -
                                          {{
                                            pattern.shift_master.break_out
                                              | hour
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </v-simple-table>
                              </v-card>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </v-container>
                  </v-card-text>
                  <v-card-actions class="mx-6 pb-6">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
                    <v-btn
                      :loading="loading"
                      color="primary"
                      @click="addGroup(addItem)"
                      :disabled="!valid"
                      >{{$t('save')}}</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
          </v-col>
        </v-row>
      </v-card>
      <template>
        <!-- 
            ### DELETE DIALOG 
        -->
        <v-dialog v-model="deleteDialog" max-width="350">
          <v-card>
            <v-card-title class="headline">{{$t('delete_group')}}</v-card-title>
            <v-card-text>
              {{$t('delete_warning')}}
            </v-card-text>
            <v-card-actions class="pa-3">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="deleteDialog = false"
                >{{$t('cancel')}}</v-btn
              >
              <v-btn color="primary" @click="deleteGroup(itemToDelete.id)"
                >{{$t('yes')}}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Update Dialog -->
        <v-dialog v-model="updateDialog" persistent max-width="300">
          <v-card>
            <v-card-title class="headline">{{$t('update_group')}}</v-card-title>
            <v-card-text>
              Jika merubah data group <b>{{updateGroupName}}</b>, maka data karyawan yang ada di group ini akan ikut berubah.
            </v-card-text>
            <v-card-actions class="pa-3">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="updateDialog = false"
                >{{$t('cancel')}}</v-btn
              >
              <v-btn color="primary" @click="saveToAPI(editedItem)"
                >{{$t('save')}}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-row>
          <v-col md="4">
            <v-card
              v-if="!loading"
              height="780"
              max-height="100%"
              class="pb-0 overflow-y-auto"
            >
              <v-row class="pa-4" justify="space-between">
                <v-col>
                  <div class="scrollingtable">
                    <v-autocomplete
                      v-model="search_group"
                      :items="autoCompleteList"
                      color="white"
                      hide-no-data
                      hide-selected
                      item-text="name"
                      item-value="value"
                      :placeholder="$t('find_group')"
                      @change="searchGroup()"
                      @keyup.enter="searchGroup()"
                      prepend-inner-icon="mdi-magnify"
                    ></v-autocomplete>
                    <v-treeview
                      :items="tree_view"
                      activatable
                      color="primary"
                      transition
                    >
                      <template v-slot:label="{ item, open }">
                        <div @click="editItem(item)" style="cursor: pointer">
                          <v-icon v-if="!item.file">{{
                            open ? "mdi-folder-open" : "mdi-folder"
                          }}</v-icon>
                          <span>{{ item.name }}</span>
                        </div>
                      </template>
                    </v-treeview>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col md="8" class="mt-3">
            <v-form v-model="valid">
            <v-card v-if="!loading">
              <v-row v-if="refreshData">
                <v-col class="d-flex">
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-list-item-content>
                          <v-col md="6">
                            <span class="headline">{{$t('group_details')}}</span>
                          </v-col>
                        </v-list-item-content>
                        <v-list-item-content>
                          <v-col offset-md="9" md="4">
                            <v-icon
                              small
                              class="mr-2"
                              color="primary"
                              @click="isEdit = editedItem.name ? true : false"
                              >mdi-pencil</v-icon
                            >
                            <v-icon
                              small
                              color="error"
                              @click="deleteItem(editedItem)"
                              >mdi-delete</v-icon
                            >
                          </v-col>
                        </v-list-item-content>
                      </v-row>
                      <v-row>
                        <v-col md="6" sm="6">
                          <v-text-field
                            :label="$t('group_name')"
                            class="mt-2"
                            v-model="editedItem.alias"
                            :disabled="!isEdit"
                            :rules="[validator.GroupRequired]"
                          ></v-text-field>
                        </v-col>
                        <v-col md="6" sm="6" v-if="refreshZone">
                          <v-row v-for="(item, j) of editedItem.zoneMasterId" v-bind:key="j" class="pt-0">
                            <v-col md="8" sm="8" class="pt-1">
                              <v-autocomplete
                                :label="$t('zones')"
                                :items="group_zone"
                                item-text="zonename"
                                v-model="editedItem.zoneMasterId[j]"
                                item-value="id"
                                :rules="[rules.required]"
                                :disabled="!isEdit"
                              ></v-autocomplete>
                            </v-col>
                            <v-col md="4" sm="4" class="pt-1">
                              <div>
                                <v-btn :disabled="!isEdit" icon class="mt-4" color="error" @click="removeZoneItem(editedItem.zoneMasterId, editedItem.zoneMasterId[j])">
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                                <v-btn v-if="j == editedItem.zoneMasterId.length-1" :disabled="!isEdit" icon class="mt-4" color="primary" @click="addZoneItem(editedItem.zoneMasterId)">
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="6" sm="6">
                          <v-select
                            :label="$t('level')"
                            :items="level_array"
                            v-model="editedItem.level"
                            class="mt-2"
                            @change="getLevel($event, editedItem.alias, editedItem.id)"
                            :disabled="!isEdit"
                          ></v-select>
                        </v-col>
                        <v-col md="6" sm="6">
                          <v-autocomplete
                            v-if="editedItem.level != 1"
                            :label="$t('group_parent')"
                            :items="group_list"
                            v-model="editedItem.parentSlug"
                            item-text="alias"
                            class="mt-2"
                            item-value="slug"
                            :disabled="!isEdit"
                          ></v-autocomplete>
                        </v-col>
                        <v-col md="6" sm="6">
                          <v-select
                            :items="isShifted"
                            v-model="editedItem.is_shifted"
                            item-text="name"
                            item-value="id"
                            :label="$t('schedule_type')"
                            class="mt-2"
                            :disabled="!isEdit"
                            @change="onChangeIsShifted"
                          ></v-select>
                          <span style="color: red !important;">
                            <i v-if="excludeShifting() === false && editedItem.is_shifted === true && shift_temp === false && isEdit === true">
                              ({{ $t('schedule_type_label') }})
                            </i>
                          </span>
                        </v-col>
                        <v-col md="6" sm="6" v-if="excludeShifting()">
                          <v-autocomplete
                            v-if="editedItem.is_shifted == 1"
                            v-model="editedItem.shiftPatternMasterId"
                            :items="listPattern"
                            item-text="schedule_name"
                            item-value="id"
                            :label="$t('list_schedule_pattern')"
                            class="mt-2"
                            :disabled="!isEdit"
                            :rules="rules2"
                            @change="onChangePattern"
                          ></v-autocomplete>
                        </v-col>
                        <v-col offset="6" md="6" sm="6" v-if="editedItem.is_shifted == 1 && (excludeShifting())">
                          <v-menu ref="menu" v-model="edit_menu_start" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :value="dateFormatted(edit_start_date)"
                                :label="$t('start_date')"
                                readonly
                                v-on="on"
                                color="primary"
                                :disabled="!isEdit"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="edit_start_date"
                              @change="onStartDateChange"
                              no-title
                              scrollable
                              :locale="$t('locale')"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                          <v-col md="6" sm="6" v-if="gcLiveTrackingEnabled">
                          <p class="subtitle-2 font-weight-bold" style="margin: 1px;">{{$t('group_live_tracking')}}</p>
                          <span>(<i>{{$t('group_desc_tracking')}}</i>)</span>
                        </v-col>
                        <v-col md="6" sm="6" v-if="gcLiveTrackingEnabled">
                          <v-switch
                            v-model="editedItem.isTrackLocation "
                            inset
                            color="success"
                            value
                            input-value="true"
                            :disabled="!isEdit"
                           :label="$t('group_live_tracking')"
                          ></v-switch>
                        </v-col>
                        <v-col md="6" sm="6">
                          <p class="subtitle-2 font-weight-bold" style="margin: 1px;">{{$t('group_lock_time')}}</p>
                          <span>(<i>{{$t('group_desc_time')}}</i>)</span>
                        </v-col>
                        <v-col md="6" sm="6">
                          <p class="subtitle-2 font-weight-bold" style="margin: 1px;">{{$t('group_lock_location')}}</p>
                          <span>(<i>{{$t('group_desc_location')}}</i>)</span>
                        </v-col>
                        <v-col md="6" sm="6">
                          <v-switch
                            v-model="editedItem.mandatoryCheckOut"
                            inset
                            color="success"
                            value
                            input-value="true"
                            :disabled="!isEdit"
                            :label="$t('mandatoryCheckOut')"
                          ></v-switch>
                        </v-col>
                        <v-col md="3" sm="3">
                          <v-switch
                            v-model="editedItem.strictAreaIn"
                            inset
                            color="success"
                            value
                            input-value="true"
                            :disabled="!isEdit"
                            :label="$t('strictAreaIn')"
                          ></v-switch>
                        </v-col>
                        <v-col md="3" sm="3">
                          <v-switch
                            v-model="editedItem.strictAreaOut"
                            inset
                            color="success"
                            value
                            input-value="true"
                            :disabled="!isEdit"
                           :label="$t('strictAreaOut')"
                          ></v-switch>
                        </v-col>
                      </v-row>
                      <div v-if="editedItem.is_shifted == 0">
                        <span class="title text--primary">Schedule</span>
                        <v-row>
                          <v-col md="4" sm="4">
                            <v-text-field
                             :label="$t('tolerance_in_min')"
                              v-model="editedItem.tolerance"
                              :rules="rules4"
                              :disabled="!isEdit"
                            ></v-text-field>
                          </v-col>
                          <v-col md="4" sm="4">
                            <v-text-field
                              :label="$t('interval_in_min')"
                              v-model="editedItem.interval"
                              :rules="rules4"
                              :disabled="!isEdit"
                            ></v-text-field>
                          </v-col>
                          <v-col md="4" sm="4">
                            <v-select
                             :label="$t('timezone')"
                              v-model="editedItem.timezone"
                              :disabled="!isEdit"
                              :items="timezone"
                              item-value="id"
                              item-text="name"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-list-item-content>
                          <span class="subtitle-2 font-weight-bold"
                            >{{$t('schedule_in')}} :</span
                          >
                        </v-list-item-content>
                        <v-row>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                              :label="$t('mon')"
                              v-model="editedItem.schedule.monday_in"
                              type="time"
                              :disabled="!isEdit"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('tue')"
                              v-model="editedItem.schedule.tuesday_in"
                              type="time"
                              :disabled="!isEdit"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                              :label="$t('wed')"
                              v-model="editedItem.schedule.wednesday_in"
                              type="time"
                              :disabled="!isEdit"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('thu')"
                              v-model="editedItem.schedule.thursday_in"
                              type="time"
                              :disabled="!isEdit"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                              :label="$t('fri')"
                              v-model="editedItem.schedule.friday_in"
                              type="time"
                              :disabled="!isEdit"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0"></v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('sat')"
                              v-model="editedItem.schedule.saturday_in"
                              type="time"
                              :disabled="!isEdit"
                              :rules="[rules.weekend]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('sun')"
                              v-model="editedItem.schedule.sunday_in"
                              type="time"
                              :disabled="!isEdit"
                              :rules="[rules.weekend]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-list-item-content>
                          <span class="subtitle-2 font-weight-bold"
                            >{{$t('schedule_out')}} :</span
                          >
                        </v-list-item-content>
                        <v-row>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('mon')"
                              v-model="editedItem.schedule.monday_out"
                              type="time"
                              :disabled="!isEdit"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('tue')"
                              v-model="editedItem.schedule.tuesday_out"
                              type="time"
                              :disabled="!isEdit"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('wed')"
                              v-model="editedItem.schedule.wednesday_out"
                              type="time"
                              :disabled="!isEdit"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('thu')"
                              v-model="editedItem.schedule.thursday_out"
                              type="time"
                              :disabled="!isEdit"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                              :label="$t('fri')"
                              v-model="editedItem.schedule.friday_out"
                              type="time"
                              :disabled="!isEdit"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0"></v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('sat')"
                              v-model="editedItem.schedule.saturday_out"
                              type="time"
                              :disabled="!isEdit"
                              :rules="[rules.weekend]"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="2" md="2" class="pb-0 pt-0">
                            <v-text-field
                             :label="$t('sun')"
                              v-model="editedItem.schedule.sunday_out"
                              type="time"
                              :disabled="!isEdit"
                              :rules="[rules.weekend]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </div>
                      <div v-else-if="editedItem.is_shifted == 1 && excludeShifting()">
                        <div v-if="selectedPattern">
                          <span class="title text--primary">{{$t('shift_details')}}</span>
                          <v-row>
                            <v-col md="3">
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title
                                    class="subtitle-2 font-weight-bold"
                                    >{{$t('total_days')}}</v-list-item-title
                                  >
                                  <v-list-item-title class="subtitle-1">{{
                                    selectedPattern.shift_days.length
                                  }}</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-col>
                            <v-col md="3">
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title
                                    class="subtitle-2 font-weight-bold"
                                    >{{$t('tolerance')}}</v-list-item-title
                                  >
                                  <v-list-item-title class="subtitle-1">{{
                                    selectedPattern.tolerance
                                  }}</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-col>
                            <v-col md="3">
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title
                                    class="subtitle-2 font-weight-bold"
                                    >{{$t('timezone')}}</v-list-item-title
                                  >
                                  <v-list-item-title
                                    v-if="selectedPattern.timezone == 7"
                                    class="subtitle-1"
                                    >WIB</v-list-item-title
                                  >
                                  <v-list-item-title
                                    v-else-if="selectedPattern.timezone == 8"
                                    class="subtitle-1"
                                    >WITA</v-list-item-title
                                  >
                                  <v-list-item-title
                                    v-else-if="selectedPattern.timezone == 9"
                                    class="subtitle-1"
                                    >WIT</v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-card>
                                <v-simple-table noboder>
                                  <thead>
                                    <tr class="w-100">
                                      <th class="text-center">{{$t('days')}}</th>
                                      <th class="text-center">{{$t('initial_shift')}}</th>
                                      <th class="text-center">{{$t('default')}}</th>
                                      <th class="text-center">
                                        {{$t('shift_description')}}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody
                                    v-for="(item,
                                    j) of selectedPattern.shift_days"
                                    v-bind:key="j"
                                    fluid
                                  >
                                    <tr
                                      v-for="(pattern,
                                      k) of item.shift_patterns"
                                      v-bind:key="k"
                                    >
                                      <td class="text-center">
                                        {{ k == 0 ? item.day : "" }}
                                      </td>
                                      <td class="text-center" v-if="pattern.shift_master">
                                        {{ pattern.shift_master.schedule_code }}
                                      </td>
                                      <td class="text-center">
                                        <span v-if="pattern.default == true">
                                          ({{$t('default')}})
                                        </span>
                                        <span v-else></span>
                                      </td>
                                      <td class="pt-2 text-center" v-if="pattern.shift_master">
                                        <span class="pb-2">
                                          {{$t('start')}} - {{$t('end')}} :
                                          {{
                                            pattern.shift_master.work_in | hour
                                          }}
                                          -
                                          {{
                                            pattern.shift_master.work_out | hour
                                          }}
                                        </span>
                                        <br />
                                        <span>
                                          {{$t('break_time')}}:
                                          {{
                                            pattern.shift_master.break_in | hour
                                          }}
                                          -
                                          {{
                                            pattern.shift_master.break_out
                                              | hour
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </v-simple-table>
                              </v-card>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <div></div>
                        <div v-show="isEdit">
                          <v-btn color="primary" @click="cancelEdit()" text
                            >{{$t('cancel')}}</v-btn
                          >
                          <v-btn
                            color="primary"
                            @click="saveToAPIConfirmation(editedItem)"
                            :disabled="!valid"
                            >{{$t('save')}}</v-btn
                          >
                        </div>
                      </v-card-actions>
                    </v-container>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>
            </v-form>
          </v-col>
        </v-row>
        <!-- Skeleton Loader -->
        <v-skeleton-loader
          class="mx-auto"
          type="table-tbody"
          v-if="loading"
        ></v-skeleton-loader>
      </template>
      <template v-slot:item.timezone="{ item }">
        <div v-if="item.timezone == 7">WIB</div>
        <div v-if="item.timezone == 8">WITA</div>
        <div v-if="item.timezone == 9">WIT</div>
      </template>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "groups",
  data() {
    return {
      edit_menu_start: false,
      add_menu_start: false,
      edit_start_date: "",
      add_start_date: "",
      refreshZone: true,
      tempEdit: null,
      autoCompleteList: [],
      temp: null,
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      alert: false,
      alert_text: "",
      alert_mode: "",
      headers: [
        { text: this.$i18n.t('group_name'), value: "alias" },
        { text: this.$i18n.t('tolerance'), value: "tolerance" },
        { text: this.$i18n.t('interval'), value: "interval" },
        { text: this.$i18n.t('timezone'), value: "timezone_edit" },
        { text: this.$i18n.t('details'), value: "details", align: "center" },
        { text: this.$i18n.t('action'), value: "action" },
      ],
      scheduleHeaders: [this.$i18n.t('mon'), this.$i18n.t('tue') , this.$i18n.t('wed') , this.$i18n.t('thu') , this.$i18n.t('fri') , this.$i18n.t('sat'), this.$i18n.t('sun')],
      addItem: {
        alias: "",
        companyId: "",
        level: "",
        parentSlug: "",
        group_id: "",
        tolerance: 0,
        interval: 60,
        schedule_name: null,
        zoneMasterId: [null],
        activate_date: null,
        strictAreaIn: false,
        strictAreaOut: false,
        mandatoryCheckOut: false,
        isTrackLocation: false,
      },
      editedItem: {
        alias: "",
        companyId: "",
        level: "",
        parentSlug: "",
        group_id: "",
        tolerance: 0,
        interval: 60,
        name_group: "",
        schedule: {
          monday_in: null,
          monday_out: null,
          tuesday_in: null,
          tuesday_out: null,
          wednesday_in: null,
          wednesday_out: null,
          thursday_in: null,
          thursday_out: null,
          friday_in: null,
          friday_out: null,
          saturday_in: null,
          saturday_out: null,
          sunday_in: null,
          sunday_out: null,
          group_id: "",
        },
        zones: {
          groupId: "",
          zoneMasterId: "",
          id: "",
        },
        zoneMasterId: [null],
        activate_date: null,
        strictAreaIn: false,
        strictAreaOut: false,
      },
      itemToDelete: {
        id: "",
        name_group: "",
        companyId: "",
      },
      editedIndex: -1,
      groups: [
        {
          id: "",
          name_group: "",
          companyId: "",
        },
      ],
      group_report: [],
      detailZones: [],
      detailSchedule: {},
      loading: true,
      loadingDetails: true,
      dialog: false,
      addDialog: false,
      detailsDialog: false,
      deleteDialog: false,
      search_group: "",
      group_detail: [],
      group_list: [],
      level_array: [1, 2, 3, 4, 5, 6],
      group_zone: [],
      expanded: [],
      singleExpand: false,
      company_id: this.$store.state.company,
      user_email: this.$store.state.user_email,
      user_group: [],
      rules: {
        required: (value) => {
          if (value === 0) return true;
          if (value === null || value === undefined || value === '') {
            return this.$i18n.t('required');
          }
          return true;
        },
        minutes: (value) => !!value || "By Minutes.",
        weekend: (value) => !!value || "Fill with 00:00",
        numberRule: (value) => {
          if (value < 0) return "Please enter a positive number";
          return true;
        },
      },
      rules2: [(value) =>(value == 0 ? true: value ? value > 0 : !!value || this.$i18n.t('required'))],
       rules4: [
        v => {
          if (v === null || v === undefined || v === '') {
            return this.$i18n.t('required');
          }
          return /^(0|[1-9][0-9]{0,2})$/.test(v) || this.$i18n.t('999_required');
        }
      ],
      valid: true,
      groupId: "",
      tree_view: [],
      scheduleEdit: [],
      isEdit: false,
      shift_temp: false,
      isDelete: false,
      selected: "",
      tree_zone: [],
      timezone: [
        {
          name: "WIB",
          id: 7,
        },
        {
          name: "WITA",
          id: 8,
        },
        {
          name: "WIT",
          id: 9,
        },
      ],
      isShifted: [
        {
          name: this.$i18n.t('regular'),
          id: false,
        },
        {
          name: this.$i18n.t('shifting'),
          id: true,
        },
      ],
      listPattern: [],
      detailsPattern: [],
      patternId: "",
      selectedPattern: null,
      refreshData: true,
      updateDialog: false,
      updateGroupName: null,
    };
  },
  methods: {
    saveToAPIConfirmation(data) {
      this.updateGroupName = data.name
      this.updateDialog = true
    },
    onStartDateChange(e) {
      const date = moment(e, 'YYYY-MM-DD').locale(this.$i18n.t('lang')).format('DD-MM-YYYY')
      if (this.isEdit) {
        if(this.editedItem.is_shifted) {
          if (date != 'Invalid date') {
            this.editedItem.activate_date = date
          } else {
            this.editedItem.activate_date = moment().locale(this.$i18n.t('lang')).format('DD-MM-YYYY')
          }
        }
        this.edit_menu_start = false
      } else {
        if(this.addItem.isShifted) {

          if (date != 'Invalid date') {
            this.addItem.activate_date = date
          } else {
            this.addItem.activate_date = moment().locale(this.$i18n.t('lang')).format('DD-MM-YYYY')
          }
        }
        this.add_menu_start = false
      }
    },
    dateFormatted(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("DD MMMM YYYY")
    },
    setRefreshZone() {
      this.refreshZone = false
      setTimeout(() => {
        this.refreshZone = true
      }, 10);
    },
    setRefreshData() {
      this.refreshData = false
      setTimeout(() => {
        this.refreshData = true
      }, 10);
    },
    addZoneItem(item = []) {
      // if (item.length < 5 ) {
        item.push(null)
      // } else {
      //   this.showMessage('warning', 'Maximum 5 Zones')
      // }
      this.setRefreshZone()
    },
    removeZoneItem(item = [], index) {
      if (item.length > 1) {
        const ind = item.findIndex(e => {
              return e == index
            
            })
        item.splice(ind, 1)
      } else {
        this.showMessage('error', 'Zone Required')
      }
      this.setRefreshZone()
    },
    addScheduleInit() {
      if (!this.editedItem.schedule) {
        this.editedItem.schedule = {};
      }
    },
    onChangePattern(id) {
      this.selectedPattern = this.listPattern.find((e) => {
        return e.id == id;
      });
    },
    onChangeIsShifted() {
      this.selectedPattern = null;
      this.addItem.shiftPatternMasterId = null;
      this.editedItem.shiftPatternMasterId = null;
      this.addItem.activate_date = moment().locale(this.$i18n.t('lang')).format('DD-MM-YYYY')
      this.editedItem.activate_date = moment().locale(this.$i18n.t('lang')).format('DD-MM-YYYY')
    },
    async searchGroup(save = false) {
      if (save) {
        this.autoCompleteList = [{ name: this.$i18n.t('all'), value: "-" }];
      }

      const searchTree = async (data, string, level, resultCount) => {
        return new Promise(async (resolve) => {
          if (data) {
            const result = { data: [], count: 0 };
            let a = null;
            data.map(async (item, i) => {
              switch (level) {
                case 6:
                  if (save) {
                    this.autoCompleteList.push({
                      name: item.name,
                      value: item.name,
                    });
                  }
                  if (item.name.includes(string)) {
                    result.count++;
                    result.data.push(data[i]);
                  }
                  break;
                case 5:
                case 4:
                case 3:
                case 2:
                case 1:
                  a = await searchTree(
                    data[i].children,
                    string,
                    level + 1,
                    result.count
                  );
                  if (a.count > 0) {
                    result.count = a.count;
                    data[i].children = a.data;
                    result.data.push(data[i]);
                  } else {
                    if (item.name.includes(string)) {
                      result.count++;
                      result.data.push(data[i]);
                    }
                  }
                  if (save) {
                    this.autoCompleteList.push({
                      name: item.name,
                      value: item.name,
                    });
                  }
                  break;
              }
            });
            setTimeout(() => {
              return resolve({ data: result.data, count: result.count });
            }, 20);
          } else {
            return resolve({ data, count: resultCount });
          }
        });
      };

      let temp;
      const hitam = JSON.parse(this.temp);
      if (this.search_group.length > 0 && this.search_group != "-") {
        temp = await searchTree(hitam, this.search_group, 1, 0);
        this.tree_view = temp.data;
      } else {
        await searchTree(hitam, "", 1, 0);
        this.tree_view = hitam;
      }
    },
    shortenTime(time) {
      return moment(time, "HH:mm:ss").format("HH:mm");
    },
     excludeShifting(){
        switch (this.$store.state.company) {
          case 'demo-appsensi':
            return true;
          case 'trubus-bina-swadaya':
            return true;
          case 'prima-hotel':
            return true;
          case 'bhinneka':
            return true;
          case 'united-equipment-indonesia':
            return true;
          default:
            return false;
        }
      },
    editItem(item) {
      item.parentSlug = item.parent_slug + ":";
      item.alias = item.name;
      this.tempEdit = JSON.stringify(item);
      this.isEdit = false;
      this.getLevel(item.level, item.alias, item.companyId);
      this.editedIndex = this.groups.indexOf(item);
      this.shift_temp = item.is_shifted
      this.editedItem = Object.assign({}, JSON.parse(this.tempEdit));
      if (this.editedItem.is_shifted == 1) {
        this.onChangePattern(this.editedItem.shiftPatternMasterId);
        if (item.activate_date != 'Invalid date') {
          this.edit_start_date = moment(item.activate_date, 'DD-MM-YYYY').locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
        } else {
          this.edit_start_date = moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
          item.activate_date = moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
        }
      }
      if (item.activate_date != 'Invalid date') {
        this.edit_start_date = moment(item.activate_date, 'DD-MM-YYYY').locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
      } else {
        this.edit_start_date = moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
        item.activate_date = moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
      }
      this.addScheduleInit();
      if (item.zones) {
        this.editedItem.zoneMasterId = []
        if (item.zones.length > 0) {
          item.zones.map(zone => {
            this.editedItem.zoneMasterId.push(zone.id)
          })
        } else {
          this.editedItem.zoneMasterId = [null]
        }
      } 
    },
    cancelEdit() {
      this.isEdit = false;
      this.editedItem = JSON.parse(this.tempEdit);
    },
    onSelectShift() {
      // this.getShiftPatternDetails();
    },
    deleteItem(item) {
      if (item.id) {
        this.itemToDelete = Object.assign({}, item);
        this.deleteDialog = true;
      }
    },
    close() {
      this.dialog = false;
      this.addDialog = false;
    },
    async saveToAPI(item) {
      this.updateDialog = false
      if (item.level == 1) {
        item.parentSlug = ''
      } else {
        if (!item.parentSlug) {
          this.showMessage('warning', 'Parent Level Required')
          return null
        }
      }
      if (item.alias == '') {
          this.showMessage('warning', 'Group Name Required')
          return null
      }
      const activate_date = item.activate_date != 'Invalid date' ? item.activate_date : moment().locale(this.$i18n.t('lang')).format('DD-MM-YYYY')
      const body = {
        alias: item.alias,
        level: item.level,
        tolerance: item.tolerance,
        interval: item.interval,
        timezone: item.timezone,
        parentSlug: item.parentSlug,
        companyId: this.company_id,
        name_group: item.name_group,
        isShifted: item.is_shifted,
        shiftPatternMasterId: item.shiftPatternMasterId,
        schedule_name: item.schedule_name,
        monday_in: item.schedule.monday_in,
        monday_out: item.schedule.monday_out,
        tuesday_in: item.schedule.tuesday_in,
        tuesday_out: item.schedule.tuesday_out,
        wednesday_in: item.schedule.wednesday_in,
        wednesday_out: item.schedule.wednesday_out,
        thursday_in: item.schedule.thursday_in,
        thursday_out: item.schedule.thursday_out,
        friday_in: item.schedule.friday_in,
        friday_out: item.schedule.friday_out,
        saturday_in: item.schedule.saturday_in,
        saturday_out: item.schedule.saturday_out,
        sunday_in: item.schedule.sunday_in,
        sunday_out: item.schedule.sunday_out,
        zoneMasterId: item.zoneMasterId,
        id: item.id,
        activate_date: item.is_shifted ? activate_date : null,
        strictAreaIn: item.strictAreaIn,
        strictAreaOut: item.strictAreaOut,
        isTrackLocation: item.isTrackLocation,
        mandatoryCheckOut: item.mandatoryCheckOut,
      }
      this.loading = true
      const result = await this.$store.dispatch('editGroup', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false;
        this.isEdit = false;
        this.listByHierarchy();
        this.setRefreshData()
      }
    },
    showMessage(type, text) {
      this.alert_text = text
      this.alert_mode = type
      this.alert = true
    },
    async addGroup(item) {
      const body = {
        alias: item.alias,
        level: item.level,
        companyId: this.company_id,
        tolerance: item.tolerance,
        interval: item.interval,
        timezone: item.timezone,
        parentSlug: item.parentSlug,
        isShifted: item.isShifted,
        shiftPatternMasterId: item.shiftPatternMasterId,
        schedule_name: item.schedule_name,
        monday_in: item.monday_in,
        monday_out: item.monday_out,
        tuesday_in: item.tuesday_in,
        tuesday_out: item.tuesday_out,
        wednesday_in: item.wednesday_in,
        wednesday_out: item.wednesday_out,
        thursday_in: item.thursday_in,
        thursday_out: item.thursday_out,
        friday_in: item.friday_in,
        friday_out: item.friday_out,
        saturday_in: item.saturday_in,
        saturday_out: item.saturday_out,
        sunday_in: item.sunday_in,
        sunday_out: item.sunday_out,
        zoneMasterId: item.zoneMasterId,
        activate_date: item.activate_date != 'Invalid date' ? item.activate_date : null,
        strictAreaIn: item.strictAreaIn,
        strictAreaOut: item.strictAreaOut,
        isTrackLocation: item.isTrackLocation,
        mandatoryCheckOut: item.mandatoryCheckOut,
      }
      this.loading = true;
      const result = await this.$store.dispatch('saveGroup', body)
      this.loading = false;
      if (result) {
        this.addDialog = false;
        this.showMessage('success', this.$i18n.t('alert_save'))
      } else {
        this.addDialog = true;
      }

      this.fetchGroups();
      this.getLevel();
      this.getZone();
      this.listByHierarchy();
      this.getShiftPattern();
    },
    async fetchGroups() {
      this.loading = true
      const result = await this.$store.dispatch('getGroupByCompany', { companyId: this.company_id } )
      this.loading = false
      this.groups = result
      this.group_report = [];
      result.forEach((row) => {
        let report = {};
        report.Id = row.id;
        report.GroupName = row.name_group;
        report.Tolerance = row.tolerance;
        report.Interval = row.interval;
        report.Alias = row.alias;
        report.Timezone = row.timezone;

        this.group_report.push(report);
      })
    },
    async fetchGroupDetails(group_id) {
      this.loadingDetails = true;
      this.detailZones = "";
      const result = await this.$store.dispatch('getGroupDetailById', { groupId: group_id })
      this.loadingDetails = false;
      if (result.zone[0].zone_master) {
        this.detailZones = result.zone[0].zone_master;
      }
      if (result.schedulegroup) {
        this.detailSchedule = result.schedulegroup;
      }
    },
    async deleteGroup(group_id) {
      const result = await this.$store.dispatch('deleteGroup', {id: group_id })
      if (result) {
        this.deleteDialog = false;
        this.showMessage('success', 'Group Successfully Deleted')
      }
      this.fetchGroups();
      this.getLevel();
      this.getZone();
      this.listByHierarchy();
    },
    async getLevel(level = "", alias = null, id = null) {
      // this.loading = true;
      const isParentOfChild = (slug, id) => {
        const list = slug.split(':')
        return list.indexOf(id) >= 0 ? false : true
      }
      const result = await this.$store.dispatch('getGroupParentByLevel', { divisionLevel: level, companyId: this.company_id })
      this.group_list = result
      if (alias && id) {
        this.group_list = []
        result.map( item => {
          if (item.alias != alias) {
            if (isParentOfChild(item.slug, id)) {
              this.group_list.push(item)
            }
          }
        })
      }
    },
    async getZone() {
      this.loading = true;
      const result = await this.$store.dispatch('getZoneMasterByCompany', { companyId: this.company_id })
      this.loading = false
      this.group_zone = result.rows
    },
    async listByHierarchy() {
      this.loading = true;
      const result = await this.$store.dispatch('getGroupByHierarchyByCompany', { companyId: this.company_id })
      this.loading = false
      this.tree_view = result
      this.temp = JSON.stringify(result)
      this.searchGroup(true);
      if (result) {
        if (result[0]) {
          this.tree_zone = result[0].zones;
        }
      }
    },
    async getShiftPattern() {
      this.loading = true
      const result = await this.$store.dispatch('getShiftPatternByCompany', { companyId: this.company_id })
      this.loading = false
      result.map((tmp) => {
        let pattern = tmp;
        this.listPattern.push(pattern);
      })
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? this.$i18n.t('add_item') : this.$i18n.t('group_edit');
    },
    gcLiveTrackingEnabled() {
      return this.$store.getters.gcGetData('feature_live_tracking', 'isTrackLocation')
    },
  },
  created() {
    this.add_start_date = moment()
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    this.fetchGroups();
    this.getLevel();
    this.getZone();
    this.listByHierarchy();
    this.getShiftPattern();
  },
  watch: {
    addDialog() {
      if (this.$refs.addDialog) {
        this.isEdit = false
        this.$refs.addDialog.reset();
      }
    },
  },
};
</script>
<style>
#card {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
}
</style>